import { render } from "./BaseFormRow.vue?vue&type=template&id=2a66e33b"
import script from "./BaseFormRow.vue?vue&type=script&lang=js"
export * from "./BaseFormRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__